var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"type":"button"}},[_c('Loading',{attrs:{"outerHeight":'21px',"outerWidth":'21px',"height":'21px',"width":'21px',"color":'white transparent transparent transparent',"borderWidth":'3px'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }